export default __webpack_public_path__ + "images/cancelled_af89eb.svg";